/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Toast_Delete_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to delete private model" |
*
* @param {Private_Models_Toast_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_toast_delete_failed = /** @type {((inputs?: Private_Models_Toast_Delete_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Toast_Delete_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Löschen des privaten Modells")
	return /** @type {LocalizedString} */ ("Failed to delete private model")
});